// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"7cf977a1","230":"90d7d557","424":"31571277","578":"7419205b","786":"dd7f5539","912":"ed082382"}[chunkId] + ".chunk.css";
};